import React, { useContext, useEffect } from "react";
import { Segment, Button, Icon } from "semantic-ui-react";
import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import { RootStoreContext } from "../../../../app/stores/rootStore";
import BreadcrumbContainer from "../../../../app/common/breadcrumb/BreadcrumbContainer";
import { sectionClient } from "../../../../app/util/breadcrumbOptions";
import Sales from "./Sales";

const DashboardGraphic: React.FC = () => {
  //variables para uso la informacion del userStore
  const rootStore = useContext(RootStoreContext);
  const { lastUpdate, update, getDash, getClientByIdGraphic } = rootStore.clienStore;

  const { id } = useParams<{ id: string }>();

  useEffect(() => {
      getClientByIdGraphic(id)
      getDash(id);
  }, [getClientByIdGraphic,id,getDash]);

  document.title = "Documentos electrónicos enviados";

  return (
    <div className="configurationContent">
      <BreadcrumbContainer
        title="Documentos electrónicos enviados"
        sections={sectionClient}
      />
      <Segment >
        <div className="configurationContent">
          <Button color="blue" onClick={()=>update(id)}>
            <Icon name="redo" />
            Actualizar
          </Button>
          <label> Última actualización: {lastUpdate}</label>
          <br />
          <br />
          <Sales id={id}/>
        </div>
      </Segment>
    </div>
  );
};

export default observer(DashboardGraphic);
